import { render } from "./IndicatorTable.vue?vue&type=template&id=6b835302&scoped=true"
import script from "./IndicatorTable.vue?vue&type=script&lang=js"
export * from "./IndicatorTable.vue?vue&type=script&lang=js"

import "./IndicatorTable.vue?vue&type=style&index=0&id=6b835302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b835302"]])

export default __exports__